module.exports = __webpack_public_path__ + "img/promotions-bg-1248.8e595bba.png";